import { useState, useRef, FormEvent } from 'react';

export default function NewsletterForm() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qs04ue3oq4jqumtps0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          email: formData.get('email') as string,
          form_name: '黑料社区新闻简报订阅',
        }).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const code = parsed?.code;
      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;

      if (response.ok && code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setErrorMsg(serverMsg || '订阅失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后再试');
    }
  };

  return (
    <div className="bg-background-100 border border-background-300/60 rounded-xl p-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-mail-send-line text-primary-400 text-lg"></i>
        </div>
        <h3 className="text-sm font-heading font-bold text-foreground-200">
          爆料速递
        </h3>
      </div>
      <p className="text-xs text-foreground-500 mb-4 leading-relaxed">
        订阅我们的新闻简报，第一时间获取最新娱乐圈爆料！
      </p>

      {status === 'success' ? (
        <div className="bg-accent-100/20 border border-accent-500/30 rounded-lg p-4 text-center">
          <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center">
            <i className="ri-checkbox-circle-line text-accent-400 text-xl"></i>
          </div>
          <p className="text-sm text-accent-400 font-semibold">订阅成功！</p>
          <p className="text-xs text-foreground-500 mt-1">感谢您的订阅，最新爆料将第一时间送达！</p>
        </div>
      ) : (
        <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="">
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="antispam-field"
          />
          <div className="flex flex-col gap-3">
            <input
              type="email"
              name="email"
              required
              placeholder="请输入您的邮箱地址"
              className="w-full px-4 py-2.5 bg-background-200 border border-background-300/60 rounded-lg text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
            />
            <button
              type="submit"
              className="w-full px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line mr-1.5"></i>立即订阅
            </button>
          </div>
          {status === 'error' && (
            <p className="text-xs text-primary-400 mt-2">{errorMsg}</p>
          )}
        </form>
      )}
    </div>
  );
}